<template>
    <div class="weight-600 address-box text-center">
        <div>
            {{practiceDetails.Address1}}
        </div>
        <div>
            {{practiceDetails.City}} {{practiceDetails.State}} {{practiceDetails.Zip}}
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: "ClientPracticeAddress",
    computed: {
        ...mapGetters({
            clientPracticeDetails: 'clientPracticeDetails',
            selectedPractice: 'selectedPractice'
        }),
        practiceDetails:function (params) {
            if(this.selectedPractice!=null){
                return this.selectedPractice;
            } 
            return this.clientPracticeDetails;
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/ClientPracticeAddress.vue